import React, { useEffect, useState } from 'react';
import { VOTER_ORANGE, voterIcons } from '../../component/voterCardIcons';
import '../../style/speakSearch.css';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import '../../style/dashboard.css';
import { useAppId } from '../../context/AppIdContext';
import Header from '../../component/header';
import WhatsappSlipButton from '../../component/WhatsappSlipButton';
import PracharButton from '../../component/PracharButton';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const MyVoter = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const {
        appId,
        language,
        userId
    } = useAppId();

    const lang = language || 'en';

    const [loading, setLoading] = useState(true);
    const [voters, setVoters] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filterType, setFilterType] = useState('all'); // 'all', 'survey_available', 'survey_not_available', 'survey_pending'
    const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 50;

    // Helper function to convert Status 'D', 'C', 'P', 'N' to Full Form
    const getStatusFullForm = (statusCode) => {
        switch (statusCode?.toUpperCase()) {
            case 'D': return 'Doubtful';
            case 'C': return "Can't Say";
            case 'P': return 'Positive';
            case 'N': return 'Negative';
            default: return statusCode || 'Voted';
        }
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isFilterDropdownOpen && !event.target.closest('.filter-dropdown-container')) {
                setIsFilterDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isFilterDropdownOpen]);

    // Get filter button text
    const getFilterButtonText = () => {
        switch (filterType) {
            case 'survey_available': return "Survey Available";
            case 'survey_not_available': return "Survey Not Available";
            case 'survey_pending': return "Survey Pending";
            default: return "All";
        }
    };

    // Translation dictionary
    const t = {
        en: {
            pageTitle: "My Voters",
            subtitlePrefix: "Voter Captain Voters",
            searchVoter: "Search Voter...",
            loadingData: "Loading Data...",
            noVoters: "No Voters Found.",
            fatherHusband: "F/S :",
            address: "Address :",
            serialNo: "Sr No. :",
            mobile: "Mobile :",
            idCardNo: "ID Card No :",
            boothNo: "Booth No :",
            houseNo: "House No :",
            pollingLoc: "Voting Loc :",
            call: "Call",
            text: "Text",
            slip: "Slip",
            prachar: "Prachar",
            print: "Print",
            family: "Family",
            addSurvey: "Add Survey",
            all: "All",
            surveyAvailable: "Survey Available",
            surveyNotAvailable: "Survey Not Available",
            surveyPending: "Survey Pending",
            editMobileTitle: "Update Mobile Number",
            mobilePlaceholder: "Enter 10-digit mobile number",
            mobileErrorLength: "Mobile number must be 10 digits",
            mobileErrorStart: "Number must start with 6, 7, 8, or 9",
            cancel: "Cancel",
            save: "Save",
            saving: "Saving...",
            mobileUpdateSuccess: "Mobile number updated successfully!",
            mobileUpdateFailed: "Failed to update mobile number.",
            mobileUpdateError: "An error occurred while updating the mobile number.",
            mobileNotAvailable: "Mobile number is not available for this voter.",
            addressNotAvailable: "Address not available!"

        },
        hi: {
            pageTitle: "मेरे मतदाता",
            subtitlePrefix: "मतदाता कैप्टन के मतदाता",
            searchVoter: "मतदाता खोजें...",
            loadingData: "डेटा लोड हो रहा है...",
            noVoters: "कोई मतदाता नहीं मिला।",
            fatherHusband: "पिता/पति :",
            address: "पता :",
            serialNo: "क्रमांक :",
            mobile: "मोबाइल :",
            idCardNo: "पहचान पत्र नं.:",
            boothNo: "बूथ नं :",
            houseNo: "घर नं :",
            pollingLoc: "मतदान स्थान :",
            call: "कॉल",
            text: "मैसेज",
            slip: "पर्ची",
            prachar: "प्रचार",
            print: "प्रिंट",
            family: "परिवार",
            addSurvey: "सर्वेक्षण जोड़ें",
            all: "सभी",
            surveyAvailable: "सर्वेक्षण उपलब्ध",
            surveyNotAvailable: "सर्वेक्षण अनुपलब्ध",
            surveyPending: "सर्वेक्षण लंबित",
            editMobileTitle: "मोबाइल नंबर अपडेट करें",
            mobilePlaceholder: "10 अंकों का मोबाइल नंबर दर्ज करें",
            mobileErrorLength: "मोबाइल नंबर 10 अंकों का होना चाहिए",
            mobileErrorStart: "नंबर 6, 7, 8, या 9 से शुरू होना चाहिए",
            cancel: "रद्द करें",
            save: "सेव करें",
            saving: "सेव हो रहा है...",
            mobileUpdateSuccess: "मोबाइल नंबर सफलतापूर्वक अपडेट हो गया!",
            mobileUpdateFailed: "मोबाइल नंबर अपडेट करने में विफल।",
            mobileUpdateError: "मोबाइल नंबर अपडेट करते समय एक त्रुटि हुई।",
            mobileNotAvailable: "इस मतदाता के लिए मोबाइल नंबर उपलब्ध नहीं है।",
            addressNotAvailable: "पता उपलब्ध नहीं है!"

        },
        gu: {
            pageTitle: "મારા મતદારો",
            subtitlePrefix: "મતદાર કેપ્ટન ના મતદારો",
            searchVoter: "મતદાર શોધો...",
            loadingData: "ડેટા લોડ થઈ રહ્યો છે...",
            noVoters: "કોઈ મતદાર મળ્યા નથી.",
            fatherHusband: "પિતા/પતિ :",
            address: "સરનામું :",
            serialNo: "ક્રમાંક :",
            mobile: "મોબાઇલ :",
            idCardNo: "ઓળખ કાર્ડ નં :",
            boothNo: "બૂથ નં :",
            houseNo: "ઘર નં :",
            pollingLoc: "મતદાન સ્થળ :",
            call: "કૉલ",
            text: "સંદેશ",
            slip: "સ્લિપ",
            prachar: "પ્રચાર",
            print: "પ્રિન્ટ",
            family: "કુટુંબ",
            addSurvey: "સર્વે ઉમેરો",
            all: "બધા",
            surveyAvailable: "સર્વે ઉપલબ્ધ",
            surveyNotAvailable: "સર્વે અનુપલબ્ધ",
            surveyPending: "સર્વે બાકી",
            editMobileTitle: "મોબાઇલ નંબર અપડેટ કરો",
            mobilePlaceholder: "10 અંકોનો મોબાઇલ નંબર દાખલ કરો",
            mobileErrorLength: "મોબાઇલ નંબર 10 અંકોનો હોવો જોઈએ",
            mobileErrorStart: "નંબર 6, 7, 8, અથવા 9 થી શરૂ થવો જોઈએ",
            cancel: "રદ કરો",
            save: "સેવ કરો",
            saving: "સેવ થઈ રહ્યું છે...",
            mobileUpdateSuccess: "મોબાઇલ નંબર સફળતાપૂર્વક અપડેટ થયો!",
            mobileUpdateFailed: "મોબાઇલ નંબર અપડેટ કરવામાં નિષ્ફળ.",
            mobileUpdateError: "મોબાઇલ નંબર અપડેટ કરતી વખતે એક ભૂલ આવી.",
            mobileNotAvailable: "આ મતદાર માટે મોબાઇલ નંબર ઉપલબ્ધ નથી.",
            addressNotAvailable: "સરનામું ઉપલબ્ધ નથી!"

        }
    };

    const txt = t[lang];

    // --- Edit Mobile State ---
    const [isEditMobileOpen, setIsEditMobileOpen] = useState(false);
    const [editingVoter, setEditingVoter] = useState(null);
    const [newMobile, setNewMobile] = useState('');
    const [isSavingMobile, setIsSavingMobile] = useState(false);



    // --- Edit Mobile API Call ---
    const handleUpdateMobile = async () => {
        if (!newMobile || newMobile.length !== 10) {
            alert(txt.mobileErrorLength);
            return;
        }

        setIsSavingMobile(true);
        try {
            const payload = {
                app_id: appId?.toString(),
                voter_id: editingVoter.idcard_no,
                mobile_no: newMobile,
                modify_by: userId?.toString() || "1"
            };

            const response = await axios.post(`${BASE_URL}/api/upd_voter_mobile`, payload);

            if (response.data.success || response.data.Success === "1") {
                alert(txt.mobileUpdateSuccess);
                setVoters(prev => prev.map(v =>
                    v.id === editingVoter.id ? { ...v, contact_no: newMobile } : v
                ));
                setIsEditMobileOpen(false);
            } else {
                alert(txt.mobileUpdateFailed);
            }
        } catch (error) {
            console.error("Error updating mobile:", error);
            alert(txt.mobileUpdateError);
        } finally {
            setIsSavingMobile(false);
        }
    };



    useEffect(() => {
        if (!appId) {
            navigate("/");
            return;
        }
        fetchData();
    }, [appId, navigate]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axios.post(
                `${BASE_URL}/api/dis_voter_captain_voter`,
                {
                    app_id: appId,
                    user_id: userId
                }
            );
            if (response.data.success) {
                setVoters(response.data.data.result || []);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
        finally {
            setLoading(false);
        }
    };

    // Filter voters by filterType and search term
    const getFilteredData = () => {
        let filtered = [...voters];

        // Apply survey status filter
        if (filterType === 'survey_available') {
            filtered = filtered.filter(voter => voter.voter_available === true);
        } else if (filterType === 'survey_not_available') {
            filtered = filtered.filter(voter => voter.voter_available === false);
        } else if (filterType === 'survey_pending') {
            filtered = filtered.filter(voter => voter.voter_available === null);
        }

        // Apply search term filter
        const lowerSearch = searchTerm.toLowerCase();
        if (searchTerm) {
            filtered = filtered.filter(item =>
                (item.eng_f_name && item.eng_f_name.toLowerCase().includes(lowerSearch)) ||
                (item.eng_surname && item.eng_surname.toLowerCase().includes(lowerSearch)) ||
                (item.contact_no && item.contact_no.includes(lowerSearch))
            );
        }

        return filtered;
    };

    const filteredList = getFilteredData();

    // Pagination Logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredList.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredList.length / itemsPerPage);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxVisibleButtons = 5;
        if (totalPages <= maxVisibleButtons) {
            for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
        } else {
            pageNumbers.push(1);
            let startPage = Math.max(2, currentPage - 1);
            let endPage = Math.min(totalPages - 1, currentPage + 1);
            if (currentPage <= 3) endPage = 4;
            if (currentPage >= totalPages - 2) startPage = totalPages - 3;
            if (startPage > 2) pageNumbers.push('...');
            for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
            if (endPage < totalPages - 1) pageNumbers.push('...');
            pageNumbers.push(totalPages);
        }
        return pageNumbers;
    };

    // Handle filter click
    const handleFilterClick = (filter) => {
        setFilterType(filter);
        setCurrentPage(1);
        setIsFilterDropdownOpen(false);
    };

    // --- WhatsApp Message Generation Logic ---
    const handleWhatsAppShare = async (voter) => {
        if (!voter.contact_no) {
            alert("Mobile number not available for this voter.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_wtsp`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'स्त्री')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');
                if (mobile.length === 10) mobile = '91' + mobile;

                window.open(`https://wa.me/${mobile}?text=${encodedMessage}`, '_blank');

            } else {
                alert("Could not fetch family details.");
            }
        } catch (error) {
            console.error("Error generating WhatsApp slip:", error);
            alert("Error generating message.");
        }
    };

    // --- SMS Message Generation Logic ---
    const handleSmsShare = async (voter) => {
        if (!voter.contact_no) {
            alert("Mobile number not available for this voter.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_sms`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'स्त्री')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');

                window.location.href = `sms:${mobile}?body=${encodedMessage}`;

            } else {
                alert("Could not fetch family details for SMS.");
            }
        } catch (error) {
            console.error("Error generating SMS slip:", error);
            alert("Error generating SMS message.");
        }
    };

    if (loading) {
        return (
            <div className={`app-container p-4`}>
                <Header title={txt.pageTitle} />
                <div className="subtitle-container mb-4">
                    <p className="subtitle-text">
                        <span> {txt.subtitlePrefix}</span>
                    </p>
                </div>
                <div className="loader-wrapper">
                    <div className="spinner"></div>
                    <p className="loader-text">{txt.loadingData}</p>
                    <style jsx>{`
                        .app-container { background: #f8fafc; min-height: 100vh; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; }
                        .loader-wrapper { display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 60vh; width: 100%; }
                        .spinner { width: 50px; height: 50px; border: 4px solid #E5E7EB; border-top: 4px solid #2563EB; border-radius: 50%; animation: spin 1s linear infinite; margin-bottom: 16px; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1); }
                        .loader-text { color: #6B7280; font-weight: 500; font-size: 1.1rem; animation: pulse 1.5s ease-in-out infinite; }
                        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
                        @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
                    `}</style>
                </div>
            </div>
        );
    }

    return (
        <div className='app-container p-4'>

            <Header title={txt.pageTitle} />

            {/* Mobile Number Edit Modal */}
            {isEditMobileOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }} onClick={() => setIsEditMobileOpen(false)}>
                    <div className="slide-up-element" style={{ background: 'white', padding: '24px', borderRadius: '16px', width: '90%', maxWidth: '350px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' }} onClick={(e) => e.stopPropagation()}>
                        <h4 style={{ margin: '0 0 16px 0', fontSize: '18px', color: '#0f172a', fontWeight: '700' }}>{txt.editMobileTitle}</h4>
                        <p style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#64748b' }}>{editingVoter?.eng_f_name} {editingVoter?.eng_surname}</p>

                        <div style={{ marginBottom: '24px' }}>
                            <input
                                type="tel"
                                maxLength="10"
                                value={newMobile}
                                onChange={(e) => setNewMobile(e.target.value.replace(/[^0-9]/g, ''))}
                                style={{
                                    width: '100%',
                                    padding: '12px 16px',
                                    border: (newMobile && !/^[6-9]\d{9}$/.test(newMobile) && newMobile.length === 10) ? '1px solid #ef4444' : '1px solid #cbd5e1',
                                    borderRadius: '10px',
                                    fontSize: '15px',
                                    outline: 'none',
                                    boxSizing: 'border-box'
                                }}
                                placeholder={txt.mobilePlaceholder}
                                autoFocus
                            />
                            {newMobile && newMobile.length > 0 && !/^[6-9]\d{9}$/.test(newMobile) && (
                                <div style={{ fontSize: '11px', color: '#ef4444', marginTop: '6px', fontWeight: '500' }}>
                                    {newMobile.length < 10 ? txt.mobileErrorLength : txt.mobileErrorStart}
                                </div>
                            )}
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                            <button
                                onClick={() => setIsEditMobileOpen(false)}
                                style={{ padding: '10px 16px', background: 'white', color: '#475569', border: '1px solid #cbd5e1', borderRadius: '10px', cursor: 'pointer', fontWeight: '600' }}
                            >
                                {txt.cancel}
                            </button>
                            <button
                                onClick={handleUpdateMobile}
                                disabled={isSavingMobile || !/^[6-9]\d{9}$/.test(newMobile)}
                                style={{
                                    padding: '10px 20px',
                                    background: (!/^[6-9]\d{9}$/.test(newMobile)) ? '#94a3b8' : '#2563eb',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '10px',
                                    cursor: (!/^[6-9]\d{9}$/.test(newMobile)) ? 'not-allowed' : 'pointer',
                                    fontWeight: '600'
                                }}
                            >
                                {isSavingMobile ? txt.saving : txt.save}
                            </button>
                        </div>
                    </div>
                </div>
            )}


            <div className="subtitle-container mb-4">
                <p className="subtitle-text">
                    <span> {txt.subtitlePrefix}</span>
                </p>
            </div>

            {/* Search Bar and Filter Dropdown */}
            {voters.length > 0 && (
                <div className="search-filter-row mb-4">
                    <div className="search-wrapper-modern">
                        <svg className="search-icon-modern" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <input
                            className="search-input-modern"
                            type="text"
                            placeholder={txt.searchVoter}
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setCurrentPage(1);
                            }}
                        />
                        {searchTerm && (
                            <button className="clear-search-btn" onClick={() => setSearchTerm('')}>
                                <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        )}
                    </div>

                    {/* Survey Status Filter Dropdown */}
                    <div className="filter-dropdown-container">
                        <button
                            className="filter-btn"
                            onClick={() => setIsFilterDropdownOpen(!isFilterDropdownOpen)}
                        >
                            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <polygon points="22 3 2 3 10 13 10 21 14 18 14 13 22 3" />
                            </svg>
                            {getFilterButtonText()}
                            <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <polyline points="6 9 12 15 18 9" />
                            </svg>
                        </button>

                        {isFilterDropdownOpen && (
                            <div className="filter-dropdown-menu">
                                <button
                                    className={`filter-option ${filterType === 'all' ? 'active' : ''}`}
                                    onClick={() => handleFilterClick('all')}
                                >
                                    {txt.all}
                                </button>
                                <button
                                    className={`filter-option ${filterType === 'survey_available' ? 'active' : ''}`}
                                    onClick={() => handleFilterClick('survey_available')}
                                >
                                    <span className="filter-dot available-dot"></span>
                                    {txt.surveyAvailable}
                                </button>
                                <button
                                    className={`filter-option ${filterType === 'survey_not_available' ? 'active' : ''}`}
                                    onClick={() => handleFilterClick('survey_not_available')}
                                >
                                    <span className="filter-dot not-available-dot"></span>
                                    {txt.surveyNotAvailable}
                                </button>
                                <button
                                    className={`filter-option ${filterType === 'survey_pending' ? 'active' : ''}`}
                                    onClick={() => handleFilterClick('survey_pending')}
                                >
                                    <span className="filter-dot pending-dot"></span>
                                    {txt.surveyPending}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* Voter Grid */}
            <div className="row g-3">
                {currentItems.length > 0 ? currentItems.map((voter, index) => (
                    <div className="col-12 col-md-6 col-lg-4" key={voter.id || index}>
                        <div className="voter-card-clean h-100">
                            <div className="voter-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div>
                                    <span className="serial-number">{index + 1 + indexOfFirstItem}.</span>
                                    <span className="voter-name-bold ms-2">{voter.eng_f_name} {voter.eng_surname}</span>
                                </div>
                                <div>
                                    {voter.voter_available === null && (
                                        <button
                                            className="btn-add-survey"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                navigate('/voter_survey_form', { state: { voter: voter } });
                                            }}
                                        >
                                            + {txt.addSurvey}
                                        </button>
                                    )}
                                    {voter.voter_available === true && (
                                        <span className="badge-status status-positive">
                                            {getStatusFullForm(voter.voter_status)}
                                        </span>
                                    )}
                                    {voter.voter_available === false && (
                                        <span className="badge-status status-negative">
                                            {voter.not_available_reason || 'Not Available'}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="voter-body position-relative">
                                <div className="info-row"><span className="label">{txt.fatherHusband}</span><span className="value">{voter.eng_m_name || "N/A"}</span></div>
                                <div className="info-row"><span className="label">{txt.address}</span><span className="value">{voter.eng_localityid || "N/A"}</span></div>
                                <div className="info-row"><span className="label">{txt.serialNo}</span><span className="value">{voter.slnoinpart}</span></div>
                                <div className="info-row" style={{ display: 'flex', alignItems: 'center' }}>
                                    <span className="label">{txt.mobile}</span>
                                    <span className="value mobile-value" style={{ flexGrow: 1 }}>{voter.contact_no || "N/A"}</span>
                                    <svg
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setEditingVoter(voter);
                                            setNewMobile(voter.contact_no || '');
                                            setIsEditMobileOpen(true);
                                        }}
                                        style={{ cursor: 'pointer', color: '#f59e0b', width: '18px', height: '18px', flexShrink: 0 }}
                                        fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                    </svg>
                                </div>
                                <div className="info-row"><span className="label">{txt.idCardNo}</span><span className="value">{voter.idcard_no || "N/A"}</span></div>
                                <div className="info-row"><span className="label">{txt.boothNo}</span><span className="value">{voter.part_no || voter.booth_no || "N/A"}</span></div>
                                <div className="info-row"><span className="label">{txt.houseNo}</span><span className="value">{voter.eng_house_no || "N/A"}</span></div>
                                <div className="info-row"><span className="label">{txt.pollingLoc}</span><span className="value">{voter.eng_polling_location || "-"}</span></div>
                            </div>
                            <div className="voter-actions">
                                <ActionButton icon={voterIcons.call} color={VOTER_ORANGE} label={txt.call}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (!voter.contact_no || voter.contact_no === "N/A" || voter.contact_no === "-" || voter.contact_no === "") {
                                            alert("Mobile number is not available for this voter.");
                                        }
                                        else {
                                            window.open(`tel:${voter.contact_no}`, '_blank');
                                        }
                                    }}

                                />
                                <ActionButton icon={voterIcons.text} color={VOTER_ORANGE} label={txt.text} onClick={() => handleSmsShare(voter)} />
                                <WhatsappSlipButton voter={voter} />
                                <PracharButton voter={voter} />
                                <ActionButton
                                    icon={voterIcons.print} color={VOTER_ORANGE}
                                    label={txt.print}
                                    onClick={() => navigate('/printer', { state: { voter_id: voter.id } })}
                                />
                                <ActionButton icon={voterIcons.family} color={VOTER_ORANGE} label={txt.family} onClick={() => navigate('/dis_family_member', { state: { voter_id: voter.id } })} />
                            </div>
                        </div>
                    </div>
                )) : <div className="col-12 text-center p-5 text-muted">{txt.noVoters}</div>}
            </div>

            {/* Pagination */}
            {filteredList.length > itemsPerPage && (
                <div className="pagination-wrapper">
                    <div className="pagination-content">
                        <button className="pagination-nav-btn" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M15 19l-7-7 7-7" /></svg>
                        </button>
                        <div className="page-numbers">
                            {getPageNumbers().map((number, index) => (
                                <React.Fragment key={index}>
                                    {number === '...' ? <span className="page-dots">...</span> : <button className={`page-num-btn ${currentPage === number ? 'active' : ''}`} onClick={() => paginate(number)}>{number}</button>}
                                </React.Fragment>
                            ))}
                        </div>
                        <button className="pagination-nav-btn" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M9 5l7 7-7 7" /></svg>
                        </button>
                    </div>
                </div>
            )}

            <style jsx>{`
                .search-filter-row {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 16px;
                    margin-bottom: 24px;
                }
                
                .search-wrapper-modern { 
                    position: relative; 
                    flex: 1;
                    max-width: 450px;
                }
                .search-icon-modern { 
                    position: absolute; 
                    left: 16px; 
                    top: 50%; 
                    transform: translateY(-50%); 
                    color: #94a3b8; 
                    width: 18px; 
                    height: 18px; 
                }
                .search-input-modern { 
                    width: 100%; 
                    padding: 12px 42px 12px 46px; 
                    border: 1px solid #e2e8f0; 
                    border-radius: 12px; 
                    font-size: 14px; 
                    color: #1e293b; 
                    outline: none; 
                    transition: all 0.2s ease; 
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05); 
                }
                .search-input-modern:focus { 
                    border-color: #2563eb; 
                    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1); 
                }
                .clear-search-btn {
                    position: absolute;
                    right: 12px;
                    top: 50%;
                    transform: translateY(-50%);
                    background: #f1f5f9;
                    border: none;
                    border-radius: 50%;
                    padding: 6px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #64748b;
                    transition: all 0.2s;
                }
                .clear-search-btn:hover {
                    background: #e2e8f0;
                }

                /* Filter Dropdown Styles */
                .filter-dropdown-container {
                    position: relative;
                }
                .filter-btn {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    padding: 10px 16px;
                    background: white;
                    border: 1px solid #e2e8f0;
                    border-radius: 10px;
                    font-size: 13px;
                    font-weight: 600;
                    color: #1e293b;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    white-space: nowrap;
                }
                .filter-btn:hover {
                    background: #f8fafc;
                    border-color: #cbd5e1;
                }
                .filter-dropdown-menu {
                    position: absolute;
                    top: 100%;
                    right: 0;
                    margin-top: 8px;
                    background: white;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
                    min-width: 180px;
                    z-index: 100;
                    overflow: hidden;
                }
                .filter-option {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    width: 100%;
                    padding: 10px 16px;
                    border: none;
                    background: white;
                    font-size: 13px;
                    font-weight: 500;
                    color: #334155;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    text-align: left;
                }
                .filter-option:hover {
                    background: #f1f5f9;
                }
                .filter-option.active {
                    background: #eff6ff;
                    color: #2563eb;
                }
                .filter-dot {
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    display: inline-block;
                }
                .available-dot {
                    background-color: #22c55e;
                }
                .not-available-dot {
                    background-color: #ef4444;
                }
                .pending-dot {
                    background-color: #f59e0b;
                }

                /* Survey Status Styles */
                .btn-add-survey {
                    background-color: #3b82f6;
                    color: white;
                    border: none;
                    border-radius: 16px;
                    font-size: 11px;
                    font-weight: 600;
                    padding: 4px 12px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    white-space: nowrap;
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                }
                .btn-add-survey:hover {
                    background-color: #2563eb;
                    transform: translateY(-1px);
                }
                .badge-status {
                    display: inline-block;
                    border-radius: 16px;
                    font-size: 11px;
                    font-weight: 600;
                    padding: 4px 12px;
                    white-space: nowrap;
                    display: inline-flex;
                    align-items: center;
                }
                .status-positive {
                    background-color: #dcfce7;
                    color: #166534;
                    border: 1px solid #bbf7d0;
                }
                .status-negative {
                    background-color: #fee2e2;
                    color: #991b1b;
                    border: 1px solid #fecaca;
                }

                .pagination-wrapper { 
                    display: flex; 
                    justify-content: center; 
                    padding: 20px 0; 
                    position: sticky; 
                    bottom: 20px; 
                    z-index: 50; 
                    pointer-events: none; 
                }
                .pagination-content { 
                    background: white; 
                    border: 1px solid #E2E8F0; 
                    border-radius: 50px; 
                    padding: 8px 16px; 
                    display: flex; 
                    align-items: center; 
                    gap: 8px; 
                    box-shadow: 0 10px 25px rgba(0,0,0,0.1); 
                    pointer-events: auto; 
                }
                .pagination-nav-btn { 
                    width: 32px; 
                    height: 32px; 
                    border-radius: 50%; 
                    border: none; 
                    background: transparent; 
                    color: #2563EB; 
                    cursor: pointer; 
                    display: flex; 
                    align-items: center; 
                    justify-content: center; 
                }
                .page-num-btn { 
                    width: 32px; 
                    height: 32px; 
                    border-radius: 50%; 
                    border: 1px solid transparent; 
                    background: transparent; 
                    color: #475569; 
                    font-weight: 600; 
                    font-size: 14px; 
                    cursor: pointer; 
                }
                .page-num-btn.active { 
                    background: #2563EB; 
                    color: white; 
                    box-shadow: 0 2px 4px rgba(37, 99, 235, 0.3); 
                }
                .page-dots { 
                    color: #94A3B8; 
                    font-weight: bold; 
                    padding: 0 4px; 
                }

                .subtitle-container {
                    margin-top: 8px;
                    margin-bottom: 20px;
                    position: relative;
                }
                .subtitle-text {
                    font-size: 15px;
                    color: #334155;
                    margin: 0 0 10px 0;
                    font-weight: 600;
                }
                .subtitle-container::after {
                    content: "";
                    display: block;
                    width: 60px;
                    height: 3px;
                    background: linear-gradient(to right, #2563eb, #60a5fa);
                    border-radius: 3px;
                    margin-top: 4px;
                }

                @media (max-width: 768px) {
                    .search-filter-row { 
                        flex-direction: column; 
                    }
                    .search-wrapper-modern { 
                        max-width: 100%; 
                        width: 100%;
                    }
                    .filter-dropdown-container { 
                        width: 100%; 
                    }
                    .filter-btn { 
                        justify-content: center; 
                        width: 100%; 
                    }
                    .filter-dropdown-menu { 
                        right: auto; 
                        left: 0; 
                        width: 100%; 
                    }
                    .pagination-content { 
                        padding: 6px 12px; 
                        gap: 4px; 
                        transform: scale(0.9); 
                    }
                    .page-num-btn { 
                        width: 28px; 
                        height: 28px; 
                        font-size: 12px; 
                    }
                    .btn-add-survey { 
                        font-size: 10px; 
                        padding: 3px 10px; 
                    }
                    .badge-status { 
                        font-size: 10px; 
                        padding: 3px 10px; 
                    }
                }
            `}</style>
        </div>
    );
};

const ActionButton = ({ icon, color, label, link, onClick }) => {
    if (onClick) {
        return (
            <button onClick={onClick} className="action-btn-wrapper" style={{ textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
                <span className="btn-label">{label}</span>
            </button>
        );
    }

    return (
        <a href={link || "#"} className="action-btn-wrapper" style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer">
            <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
            <span className="btn-label">{label}</span>
        </a>
    );
};

export default MyVoter;
